{
  "removeButtonLabel": "Quitar",
  "removeDescription": "Pulse Eliminar para quitar la etiqueta."
}
